import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/taxis');
  };

  return (
    <section className="hero" role="banner" aria-labelledby="hero-title">
      <div className="container">
        <div className="hero-content">
          <h1 id="hero-title">יבוא רכב זה אנחנו</h1>
          <p>
            אנחנו כאן כדי להקל עליך את תהליך יבוא הרכב. אנחנו מציעים שירותי יבוא מותאמים אישית, עם ניסיון עשיר וידע בתחום.
          </p>
          <button 
            className="cta-button" 
            onClick={handleButtonClick}
            aria-describedby="hero-title"
          >
            גלה את האפשרויות שלנו עכשיו
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero; 